module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAAXNSR0IB2cksfwAAADZQTFRFAAAA////////////////////////////////////////////////////////////////////8WPG/AAAABJ0Uk5TAIjZhw5eRBuweqJsX22jvkOx96A7BgAAAIxJREFUeJx9kesShSAIhHEjqI5pvf/LnkRz7GL7j2+GhQWiUw4Y6CkcugAehUgTViIZudAJmBeYlh8wZe5xkzcsdyzZZb7StYwMqYiiKtH8M7Udos3hWPZJKRq/MmegYshNZ8rVwa8mrjeyLripbkYDfcXphO+civejMWQSVmA/D+7bN3j+flp9savFH1KxBIXapnt6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--settings-hover.png
// module id = 939
// module chunks = 0